export default __webpack_public_path__ + "images/79c68eee0b68d56e15f08123f48f3faa-dont_8.png";